"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
var React = __importStar(require("react"));
var state_manager_1 = require("./state-manager");
exports.Provider = (_a = React.createContext({}), _a.Provider), exports.Consumer = _a.Consumer;
var StoreProvider = /** @class */ (function (_super) {
    __extends(StoreProvider, _super);
    function StoreProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = __assign({}, _this.props.initialState);
        state_manager_1.StateManager.registerSet(_this.onStateChange.bind(_this));
        return _this;
    }
    StoreProvider.prototype.onStateChange = function (namespace, key, value) {
        this.setState(function (prevState) {
            var _a, _b;
            return (_a = {},
                _a[namespace] = __assign({}, prevState[namespace], (_b = {}, _b[key] = value, _b)),
                _a);
        });
    };
    StoreProvider.prototype.render = function () {
        return React.createElement(exports.Provider, { value: this.state }, this.props.children);
    };
    return StoreProvider;
}(React.Component));
exports.StoreProvider = StoreProvider;
//# sourceMappingURL=store-provider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/state-manager/state-manager/store-provider.js
// module id = 525
// module chunks = 8